import type { BeckyRequestPayload } from '@wix/thunderbolt-becky-root'

export const shouldSplitByPresets = (payload: BeckyRequestPayload) => payload.shouldSplitByPresets === 'true'
export const shouldRunVsmFromPayload = (payload: BeckyRequestPayload) => payload.shouldRunVsm === 'true'
export const shouldReturnResolvedBeckyModelFromPayload = (payload: BeckyRequestPayload) =>
	payload.shouldReturnResolvedBeckyModel === 'true'

export const shouldReturnCssObject = (payload: BeckyRequestPayload) => payload.shouldGetCssResultObject === 'true'

const getShouldRunMappers = (featuresToRun?: Array<string>, featuresToIgnore?: Array<string>) => {
	if (featuresToRun?.length) {
		return featuresToRun.includes('compCssMappers')
	}
	if (featuresToIgnore?.length) {
		return !featuresToIgnore.includes('compCssMappers')
	}
	return true
}

export const getShouldRunCarmi = (
	payload: BeckyRequestPayload,
	featuresToRun?: Array<string>,
	featuresToIgnore?: Array<string>
) => {
	if (shouldSplitByPresets(payload)) {
		return false
	}

	return getShouldRunMappers(featuresToRun, featuresToIgnore)
}
